import React, { forwardRef, useState } from 'react'
import { WidgetInputTextProps } from '../../widget-inputs.d'
import styles from '../../widget-inputs.module.scss'
import { WidgetInputWrapper } from '../widget-input-wrapper/widget-input-wrapper'

export const WidgetInputText = forwardRef<
  HTMLInputElement,
  WidgetInputTextProps
>((props, ref) => {
  const {
    type,
    label,
    value,
    name,
    placeholder,
    error,
    disabled,
    required,
    autoComplete = 'off',
    // textColor,
    // backgroundColor,
    // borderColor,
    onChange,
    inputStyles,
    labelStyles,
  } = props

  const errorClass = error
    ? styles['form__field__error']
    : styles['form__field']

  const requireClass = required
    ? `${styles['form__label']} ${styles['form__label--required']}`
    : styles['form__label']

  const placeholderText = placeholder || label
  const [helpText, setHelpText] = useState(placeholderText)
  const handleOnBlur = (event: any) => {
    if (event.target.value.length !== 0) {
      setHelpText(label)
    } else {
      setHelpText(placeholderText)
    }
  }

  return (
    <WidgetInputWrapper>
      <input
        type={type}
        id={name}
        defaultValue={value}
        className={errorClass}
        placeholder={placeholderText}
        onChange={onChange}
        disabled={disabled}
        autoComplete={autoComplete}
        ref={ref}
        onFocus={() => setHelpText(label)}
        onBlur={handleOnBlur}
        style={inputStyles}
      />
      <label htmlFor={name} className={requireClass} style={labelStyles}>
        {helpText}
      </label>
      {error && (
        <span
          className={`${styles['form__message']} ${styles['form__message--visible']} ${styles['form__message--error']}`}
        >
          {error}
        </span>
      )}
    </WidgetInputWrapper>
  )
})

WidgetInputText.displayName = 'WidgetInputText'
